module.exports = __webpack_public_path__ + "static/media/christmas_2_top.c22a6fa5.svg";